/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { greenApiWebhookInstanceDataRequestSchema } from "./greenApiWebhookInstanceDataRequestSchema.ts";
import { greenApiWebhookMessageDataRequestSchema } from "./greenApiWebhookMessageDataRequestSchema.ts";
import { greenApiWebhookSenderDataRequestSchema } from "./greenApiWebhookSenderDataRequestSchema.ts";

export const greenApiWebhookRequestSchema = z.object({
	instanceData: greenApiWebhookInstanceDataRequestSchema,
	senderData: greenApiWebhookSenderDataRequestSchema,
	messageData: greenApiWebhookMessageDataRequestSchema,
});
